const booking = {
  bookingInformation: "Informasi Pemesanan", // translated 
  cancellationPolicy: "Kebijakan Pembatalan", // translated 
  ourCancellationPolicy: "Kebijakan Pembatalan kami", // translated 
  thisAupersedesAnyCancellationPolicyInRemarksAbove:
    "Ini menggantikan kebijakan pembatalan apa pun dalam keterangan di atas", // translated 
  thisBookingIsNonNefundable: "Pemesanan ini tidak dapat dikembalikan", // translated 
  paymentTerms: "Syarat pembayaran", // translated 
  paymentWillBeTakenFromYourDefault: "Pembayaran akan diambil dari default Anda", // translated 
  paymentMethod: "Cara Pembayaran", // translated 
  afterTheFreeCancellationPeriodIfApplicable:
    "setelah periode pembatalan gratis jika berlaku", // translated 
  prebook: "Pesan terlebih dahulu", // translated 
  guests: "Tamu", // translated 
  payment: "Pembayaran", // translated 
  byClicking: "Dengan mengklik", // translated 
  youAreAgreeingToOur: "Anda menyetujui kami", // translated 
  termsAndConditions: "syarat dan Ketentuan", // translated 
  lastBookableDate: "Tanggal Pemesanan Terakhir", // translated 
  customerRemarksTextfield: "Komentar Pelanggan", // translated 
  request: "Meminta", // translated 
};


export default booking;
